import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

import './styles.scss'

class PageContainer extends Component {
  ALLOWED_MODIFIERS = ['withFooter', 'withHeader']

  componentClassNames = () => {
    return bemClasses(
      'page-container',
      this.ALLOWED_MODIFIERS,
      this.props,
      this.props.className
    )
  }

  render = () => {
    return (
      <div className={this.componentClassNames()}>
        {this.props.children}
      </div>
    )
  }
}

export default PageContainer
